import { ISettingMenuItem } from '../interface/setting.interface';
import { PermissionKey } from '../../shared/enum/permission-key.enum';

/*=====================================
  The settings tree, in one place.

  Flat, and ordered by what a merchant is doing rather than by a heading: the
  shop itself, then the transaction, then the people, then the technical pages.
  Store is never hidden by the shopping-store toggle - it holds that toggle, and
  hiding it would leave no way to switch the shop back on.

  Read by three callers, which is why it is a constant and not a field: the
  settings sidebar draws it, the main sidebar asks whether any of it is open to
  this role before drawing Settings at all, and /settings redirects to the first
  entry the role can actually open.
======================================*/
export const SETTING_MENU_ITEMS: ISettingMenuItem[] = [
    {
        label: 'Store',
        icon: 'pi pi-shop',
        route: '/settings/store',
        permission: PermissionKey.SETTINGS_STORE,
        testId: 'setting-sidebar-store-link',
    },
    {
        label: 'Design',
        icon: 'pi pi-image',
        route: '/settings/design',
        permission: PermissionKey.SETTINGS_STORE,
        testId: 'setting-sidebar-design-link',
    },
    {
        label: 'Checkout',
        requiresShoppingStore: true,
        icon: 'pi pi-shopping-cart',
        route: '/settings/checkout',
        permission: PermissionKey.SETTINGS_STORE,
        testId: 'setting-sidebar-checkout-link',
    },
    {
        label: 'Payments',
        requiresShoppingStore: true,
        icon: 'pi pi-credit-card',
        route: '/settings/payment',
        permission: PermissionKey.SETTINGS_PAYMENTS,
        testId: 'setting-sidebar-payments-link',
    },
    {
        label: 'Shipping & Delivery',
        requiresShoppingStore: true,
        icon: 'pi pi-truck',
        route: '/settings/shipping-delivery',
        permission: PermissionKey.FULFILMENT,
        testId: 'setting-sidebar-shipping-delivery-link',
    },
    {
        label: 'Guest reviews',
        requiresShoppingStore: true,
        icon: 'pi pi-star',
        route: '/settings/engagement',
        permission: PermissionKey.SETTINGS_STORE,
        testId: 'setting-sidebar-guest-reviews-link',
    },
    {
        label: 'Communications',
        icon: 'pi pi-bell',
        route: '/settings/communications',
        permission: PermissionKey.SETTINGS_STORE,
        testId: 'setting-sidebar-communications-link',
    },
    {
        label: 'Staff & roles',
        icon: 'pi pi-users',
        route: '/settings/account',
        permission: PermissionKey.STAFF_AND_ROLES,
        testId: 'setting-sidebar-staff-roles-link',
    },
    {
        label: 'API keys',
        icon: 'pi pi-key',
        route: '/settings/api-keys',
        permission: PermissionKey.STAFF_AND_ROLES,
        testId: 'setting-sidebar-api-keys-link',
    },
    {
        label: 'Webhooks',
        icon: 'pi pi-link',
        route: '/settings/webhooks',
        permission: PermissionKey.STAFF_AND_ROLES,
        testId: 'setting-sidebar-webhooks-link',
    },
    {
        label: 'Domains',
        icon: 'pi pi-server',
        route: '/settings/domains',
        permission: PermissionKey.DOMAINS,
        testId: 'setting-sidebar-domains-link',
    },
    {
        label: 'Custom code',
        icon: 'pi pi-code',
        route: '/settings/custom-script',
        permission: PermissionKey.SETTINGS_STORE,
        testId: 'setting-sidebar-custom-code-link',
    },
];
